var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 0.5C23.0104 0.5 29.5 6.89275 29.5 14.9972C29.5 22.9796 23.0075 29.5 14.9997 29.5C6.99195 29.5 0.5 22.9796 0.5 14.9972C0.5 6.89272 6.98899 0.5 14.9997 0.5Z",
    fill: "white",
    stroke: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0602 15.9712L19.053 12.9775H16.3514V11.0351C16.3514 10.2158 16.7288 9.41774 17.9388 9.41774H19.1673V6.86892C19.1673 6.86892 18.0525 6.66699 16.9865 6.66699C14.7617 6.66699 13.3076 8.10038 13.3076 10.696V12.9775H10.834V15.9712H13.3076V23.208C13.8034 23.2907 14.3117 23.3337 14.8295 23.3337C15.3474 23.3337 15.8556 23.2907 16.3514 23.208V15.9712H19.0602Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhite);
export default __webpack_public_path__ + "static/media/facebook__white.5df5b209118bb9cb8af99d88859757fb.svg";
export { ForwardRef as ReactComponent };